export const ADMIN_EMAIL = 'CRFH@GKHZV.COM';
